module.exports = __webpack_public_path__ + "img/product.3192124f.svg";